import type {PropsWithChildren} from 'react';
import React from 'react';
import type {DataValue, Part} from 'schemaDefinition/types';
import {CopyToClipboard} from 'components/copyToClipboard';
import {FlexBox} from 'components/layout';

type Props = {
  part: Part;
  value: DataValue;
};

export function PartWithActions({
  part,
  value,
  children,
}: React.PropsWithChildren<Props>): ReturnType<
  React.FC<PropsWithChildren<Props>>
> {
  const stringValue = JSON.stringify(value);
  const valueWithoutQuotes = stringValue.substring(1, stringValue.length - 1);

  return part.actions ? (
    <FlexBox horizontal bottom>
      {children}
      {part.actions.map(action =>
        action === 'copy' ? (
          <CopyToClipboard key={action} text={valueWithoutQuotes} />
        ) : null,
      )}
    </FlexBox>
  ) : (
    <>{children}</>
  );
}
